(function () {
    "use strict";

    angular
        .module("app")
        .directive("genderSearchHelp", ["SearchFactory", genderSearchHelp]);

    function genderSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.genderKey = "";
                        scope.genderName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.genderName === scope.displayValue)) {

                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.genderSearch(function (gender) {
                        scope.setValue(gender);

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.setValue = function (gender) {
                    scope.genderKey = gender ? gender.GenderKey : "";
                    scope.genderName = gender ? gender.GenderName : "";
                    scope.displayValue = scope.genderName;
                    if (scope.prevDisplayValue !== scope.displayValue) {
                        scope.setDirtyCallback();
                    }

                    scope.prevDisplayValue = scope.displayValue;
                    scope.needToValidate = false;
                };

                scope.displayValue = scope.genderName;
                scope.prevDisplayValue = scope.displayValue;

                scope.$watch("genderName", function (newValue) {
                    scope.displayValue = newValue;
                });

                if (scope.enableKeyWatch) {
                    scope.$watch("genderKey", function (newValue) {
                        if (newValue && newValue.toString().trim().length > 0) {
                            var modalSearch = searchFactory.genderSearch(function (gender) {
                                scope.setValue(gender);
                            });
                            modalSearch.startSearch(true, [newValue], true);
                        } else {
                            scope.setValue(null);
                        }
                    });
                }

            },
            scope: { genderKey: "=", genderName: "=?", readOnly: "=", required: "=", controlName: "@", needToValidate: "=?", setDirtyCallback: "&", enableKeyWatch: "=" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

